import React from 'react';

const PageHeader = ({ eyebrow, title, italicWords = [], subtitle }) => {
  const renderTitle = () => {
    if (italicWords.length === 0) return title;
    let result = title;
    italicWords.forEach((w) => {
      result = result.replace(w, `<span class="text-[#C9A56C]">${w}</span>`);
    });
    return <span dangerouslySetInnerHTML={{ __html: result }} />;
  };

  return (
    <section className="pt-36 md:pt-44 pb-10 md:pb-14 relative z-[2]">
      <div className="content-container">
        {eyebrow && <div className="eyebrow mb-5" data-testid="page-eyebrow">{eyebrow}</div>}
        <h1
          data-testid="page-title"
          className="display text-white text-[2.2rem] sm:text-4xl md:text-5xl lg:text-[3.8rem] leading-[1.04] tracking-[-0.02em]"
        >
          {renderTitle()}
        </h1>
        {subtitle && (
          <p className="font-sans text-white/55 text-sm md:text-base mt-5 max-w-xl leading-relaxed" data-testid="page-subtitle">
            {subtitle}
          </p>
        )}
        <div className="rule-gold mt-10" />
      </div>
    </section>
  );
};

export default PageHeader;
